<section fxLayout="column" fxLayoutGap="16px" [formGroup]="group">
  <ng-container *ngFor="let item of types">
    <app-check-button [formControlName]="item.type">{{ item.translation }}</app-check-button>
  </ng-container>
</section>
